import { getOptionLabelDefaultCallback, isOptionEqualToValueDefaultCallback } from 'common/components/sharedCustomComponents/Common/helpers';
import { EntitiesSearchableCommonDropDown } from 'common/components/sharedCustomComponents/EntitiesSearchableCommonDropDown/EntitiesSearchableCommonDropDown';
import { DEFAULT_APP_SUITE } from 'common/constants/reports';
import { fetchApplicationSuites } from 'common/services/api/ApplicationSuites/ApplicationSuites.thunks';
import { ApplicationSuite } from 'common/types/Entities';
import { displayAppSuiteOptionMenuItemContent } from 'common/utils/AppSuiteEntitiesDropDownHelper';

export function AppSuiteSearchableDropDown(props: Readonly<{
        onChange: (event: unknown, value: ApplicationSuite | null) => void,
        value?: ApplicationSuite | null,
    }>) {
    const { value, onChange } = props;

    return (
        <EntitiesSearchableCommonDropDown
            initialEntityOption={DEFAULT_APP_SUITE}
            value={value}
            onChange={onChange}
            label='Application Suite'
            getOptionLabel={getOptionLabelDefaultCallback}
            isOptionEqualToValue={isOptionEqualToValueDefaultCallback}
            asyncThunkAction={fetchApplicationSuites}
            asyncThunkArgs={undefined}
            displayMenuItemContent={displayAppSuiteOptionMenuItemContent}
        />
    );
}
